<template>
  <section>
    <ul class="nav nav-tabs">
      <li v-for="tab in tabs" :key="tab" class="nav-item custom-tab">
        <button
          class="nav-link btn border"
          :class="[isActive(tab) ? 'btn-success' : 'btn-link', tabClass]"
          :disabled="isActive(tab)"
          @click="setTab(tab)"
          :data-testid="`${tab}-tab`"
        >
          {{ tab }}
        </button>
        <div v-if="showBadge(tab)">
          <span class="badge badge-pill badge-danger custom-badge">
            {{ badgeCount(tab) }}
          </span>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  name: 'dt-tabs',
  props: {
    value: String,
    tabs: Array,
    badges: {
      type: Array,
      default: () => {
        return []
      }
    },
    tabClass: String
  },
  computed: {
    status() {
      return this.value
    }
  },
  methods: {
    isActive(tab) {
      let status = this.status || ''
      return status.toUpperCase() === tab.toUpperCase()
    },
    setTab(tab) {
      this.$emit('change', tab)
    },
    showBadge(tab) {
      let show = false
      if (this.badges.length > 0) {
        let found = this.badges.find(x => x.name === tab)
        if (found) {
          if (found.count > 0) {
            show = true
          }
        }
      }
      return show
    },
    badgeCount(tab) {
      let count = 0
      if (this.badges.length > 0) {
        let found = this.badges.find(x => x.name === tab)
        if (found) {
          count = found.count
        }
      }
      return count
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-tab {
  position: relative;
}
button {
  padding: 13px 25px;
}
button:disabled {
  opacity: 1;
}
.custom-button {
  position: absolute;
  right: 60px;
  top: 5px;
  padding: 0.25rem 0.5rem;
  z-index: 10;
}
.custom-badge {
  position: absolute;
  top: -10px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-tabs.vue